import React from 'react';

import type {TaskProgressStepFieldType} from 'app/tasks/types';
type Props = {
  initial: string;
  value: string;
  isSaving: boolean;
  blocked: boolean;
  progress?: TaskProgressStepFieldType;
  onSubmit: () => void;
};
export const TaskFieldSubmitButton = ({
  initial,
  value,
  isSaving,
  blocked,
  progress,
  onSubmit,
}: Props) => {
  const isSynced =
    progress != null &&
    progress.updated_by != null &&
    progress.updated_at != null;

  if (!isSynced && !isSaving && value === '') {
    return null;
  }

  return (
    <div className="input-group-append">
      <button
        data-toggle
        type="submit"
        disabled={initial === value || isSaving || blocked}
        onClick={() => onSubmit()}
        className={`btn ${initial !== value ? 'btn-primary' : 'btn-secondary'}`}
      >
        <i
          className={`fa fa-fw ${
            isSaving
              ? 'fa-circle-notch fa-spin'
              : initial === value && isSynced
              ? 'fa-check'
              : 'fa-thumbs-up'
          }`}
        />
      </button>
    </div>
  );
};
